import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_BASE_URL } from '../config';

const API_BASE = `${API_BASE_URL}/rooms`;

export const fetchRooms = createAsyncThunk('rooms/fetchRooms', async (adminId) => {
  const response = await fetch(`${API_BASE}?adminId=${adminId}`);
  if (!response.ok) throw new Error('Failed to fetch rooms');
  return response.json();
});

export const createRoom = createAsyncThunk('rooms/createRoom', async (roomData) => {
  const response = await fetch(API_BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(roomData)
  });
  if (!response.ok) throw new Error('Failed to create room');
  return response.json();
});

export const updateRoom = createAsyncThunk('rooms/updateRoom', async ({ id, data }) => {
  const response = await fetch(`${API_BASE}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  if (!response.ok) throw new Error('Failed to update room');
  return response.json();
});

export const deleteRoom = createAsyncThunk('rooms/deleteRoom', async ({ id, adminId }) => {
  const response = await fetch(`${API_BASE}/${id}?adminId=${adminId}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete room');
  return id;
});

const roomSlice = createSlice({
  name: 'room',
  initialState: {
    rooms: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchRooms.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRooms.fulfilled, (state, action) => {
        state.loading = false;
        state.rooms = action.payload;
      })
      .addCase(fetchRooms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Create
      .addCase(createRoom.fulfilled, (state, action) => {
        state.rooms.push(action.payload);
      })
      // Update
      .addCase(updateRoom.fulfilled, (state, action) => {
        const index = state.rooms.findIndex(r => r._id === action.payload._id);
        if (index !== -1) {
          state.rooms[index] = action.payload;
        }
      })
      // Delete
      .addCase(deleteRoom.fulfilled, (state, action) => {
        state.rooms = state.rooms.filter(r => r._id !== action.payload);
      });
  }
});

export default roomSlice.reducer;
